module.exports = __webpack_public_path__ + "img/noticeon.8c850df1.png";